import React, { ReactNode, createContext, useContext } from 'react';
import { twMerge } from 'tailwind-merge';

interface GridTableContextType {
  dummy: string;
}

const GridTableContext = createContext<GridTableContextType>({ dummy: 'dummy' });

interface GridTableProps {
  children: ReactNode;
  minWidth?: string;
  className?: string;
}

const GridTable: React.FC<GridTableProps> & {
  Cell: typeof GridCell;
} = ({ children, className }) => {
  return (
    <GridTableContext.Provider value={{ dummy: 'dummy' }}>
      <div
        className={twMerge(
          'grid grid-cols-[6fr_2fr_2fr_1fr_1fr_2fr] text-secondary min-w-[800px] md:min-w-0',
          className
        )}
      >
        {children}
      </div>
    </GridTableContext.Provider>
  );
};

type GridCellProps = React.HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  isHeader?: boolean;
};

const GridCell: React.FC<GridCellProps> = ({ children, className, isHeader = false, ...props }) => {
  const context = useContext(GridTableContext);
  if (!context) {
    throw new Error('GridColumn must be used within GridTable');
  }

  const baseClasses = isHeader
    ? 'flex items-center py-3 px-4 text-left text-sm font-normal tracking-wider'
    : 'flex items-center py-8 px-4 text-left border-t border-r border-gray-300 md:border-t-0 md:border-r-0';

  return (
    <div className={twMerge(baseClasses, className)} {...props}>
      {children}
    </div>
  );
};

// Attach Row and Column as static properties
GridTable.Cell = GridCell;

export default GridTable;
